<template lang="html">
    <button class="button" type="button">
        <span>{{ label }}</span>
    </button>
</template>

<script>
export default {
    props: [
        'label'
    ],
    created: () => {}
}
</script>

<style lang="css" scoped>
    .button {
        background-color: #e8e8e1;
        padding: 10px 20px;
        color: #333;
        text-decoration: none;
        font-size: 14px;
        cursor: pointer;
        font-weight: 500;
        border: solid 1px #CECECE;
    }
</style>
